export enum DeployStatus {
  NotStarted,
  Started,
  Succeeded,
}
